/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Task_Catalog_Row_ActionsInputs */

const en_task_catalog_row_actions = /** @type {(inputs: Task_Catalog_Row_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for ${i?.task}`)
};

const pt_br2_task_catalog_row_actions = /** @type {(inputs: Task_Catalog_Row_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ações de ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Actions for {task}" |
*
* @param {Task_Catalog_Row_ActionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_row_actions = /** @type {((inputs: Task_Catalog_Row_ActionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Row_ActionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_row_actions(inputs)
	return pt_br2_task_catalog_row_actions(inputs)
});